export default {
    module: 'pages/contact'
};
